import React from 'react';
import { Star, Trophy } from 'lucide-react';

export const ScoreCard = ({ totalScore, award }) => {
  // Helper function to determine award color
  const getAwardColor = (award) => {
    const colors = {
      'Platinum': 'bg-primary/10 text-primary',
      'High Gold': 'bg-warning/10 text-warning',
      'Gold': 'bg-success/10 text-success',
      'High Silver': 'bg-info/10 text-info',
      'Silver': 'bg-base-content/10 text-base-content'
    };
    return colors[award] || 'bg-base-content/10 text-base-content';
  };

  return (
    <div className="card bg-base-200 shadow-lg">
      <div className="card-body">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base-content/70 text-sm font-medium">Total Score</h3>
            <p className="text-3xl font-bold text-base-content mt-1">{totalScore}</p>
          </div>
          <div className="p-3 bg-primary/10 rounded-lg">
            <Trophy className="w-6 h-6 text-primary" />
          </div>
        </div>
        
        {award && (
          <div className="mt-4">
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getAwardColor(award)}`}>
              {award}
            </span>
          </div>
        )}

        {/* Score Distribution visualization */}
        <div className="mt-4">
          <div className="w-full h-2 bg-base-300 rounded-full overflow-hidden">
            <div 
              className="h-full bg-primary transition-all duration-500"
              style={{ width: `${(totalScore / 300) * 100}%` }}
            />
          </div>
          <div className="flex justify-between mt-1 text-xs text-base-content/60">
            <span>0</span>
            <span>150</span>
            <span>300</span>
          </div>
        </div>
      </div>
    </div>
  );
};